import { useReveal } from "../hooks/useReveal";

const CREW = [
  {
    name: "Jason",
    role: "Lead Guitarist",
    image: "/images/crew1.png",
    bio: "A self-taught string-shredder with 13+ years of melting faces. Vashni has commanded the stage for over 60 shows with the band, driving the soaring melodic riffs and high-voltage energy of the tour.",
  },
  {
    name: "Jubal",
    role: "Bass Guitarist",
    image: "/images/crew2.png",
    bio: "The ultimate groove-master and sonic architect. Jubal lays down the thick, heart-thumping basslines that keep the crowd moving. His playing isn't just heard\u2014it's felt deep in your chest.",
  },
  {
    name: "Joel",
    role: "Keyboards & Piano",
    image: "/images/crew3.png",
    bio: "The wizard on the keys! Joel's classical piano chops meet wild, genre-bending synths to craft the band's massive atmospheric soundscapes. If you feel like you're floating, it's Joel's magic.",
  },
  {
    name: "Krishna",
    role: "Rhythm & Vocals",
    image: "/images/crew4.png",
    bio: "A true storyteller with a guitar. Krishna brings raw vocal power and relentless rhythm to the lineup. With 100+ shows under his belt, he's the rhythmic backbone keeping the energy cranked to 11.",
  },
  {
    name: "Akshay",
    role: "Percussionist",
    image: "/images/crew5.png",
    bio: "A rhythmic beast mastering the beats! Akshay fuels the stage with infectious, high-octane percussion. Sharing stages with legends like A.R. Rahman, he guarantees the crowd never stops bouncing.",
  },
  {
    name: "Ricky",
    role: "Drummer",
    image: "/images/crew6.png",
    bio: "The human metronome with a heavy-hitting punch! With over a decade of crushing kits and rocking 150+ shows with Ram, Ricky dictates the relentless, driving pulse of the show.",
  },
  {
    name: "Vivek",
    role: "Indian Folk Hand Percussionist",
    image: "/images/crew7.png",
    bio: "A master of traditional rhythms, Vivek breathes life into ancient Indian folk percussion. His intricate hand beats weave a layer of earthy, cultural authenticity that grounds the band's modern sound in deep roots.",
  },
];

export default function Crew() {
  const headRef = useReveal();
  const gridRef = useReveal();

  return (
    <section id="crew" className="py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div ref={headRef} className="reveal max-w-4xl mx-auto text-center mb-20">
          <h2 className="text-3xl md:text-5xl lg:text-6xl leading-tight text-white/90 font-serif">
            Meet the <span className="text-[#C9ED00]">crew</span>
          </h2>
          <p className="text-lg text-gray-400 mt-4 max-w-2xl mx-auto">
            Seven musicians. One stage. The full band behind Ram Miriyala's live sound.
          </p>
        </div>

        <div
          ref={gridRef}
          className="reveal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 max-w-6xl mx-auto"
        >
          {CREW.map((member, i) => (
            <div
              key={member.name}
              style={{ transitionDelay: `${i * 80}ms` }}
              className="group bg-[#111] border border-white/10 rounded-3xl overflow-hidden hover:border-[#C9ED00]/50 transition-all duration-500 cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-[3/4] overflow-hidden bg-white/5 relative">
                <img
                  src={member.image}
                  alt={`${member.name} - ${member.role}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-transparent to-transparent opacity-60" />
              </div>

              {/* Info */}
              <div className="p-6">
                <p className="text-[11px] uppercase tracking-widest text-[#C9ED00] font-medium mb-1">
                  {member.role}
                </p>
                <h3 className="text-2xl font-serif text-white leading-none mb-3">
                  {member.name}
                </h3>
                <p className="text-sm text-gray-400 leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Dot pattern background */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle, #555 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
    </section>
  );
}
